import axios from '../load_axios'

const apiBaseUrl = `${process.env.VUE_APP_API_URL}/wp-json/`;

export default {
    apiBaseUrl: apiBaseUrl,
    get(url, params) {
      return axios.get(`${this.apiBaseUrl}${url}`, {params: params});
    },
}